import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275","key":"svg-0"}],["path",{"d":"M11.683 12.317l5.759 -5.759","key":"svg-1"}],["path",{"d":"M4 5.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-2"}],["path",{"d":"M17 5.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-3"}],["path",{"d":"M17 18.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-4"}],["path",{"d":"M4 15.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0","key":"svg-5"}]]

const IconAffiliate = createReactComponent('outline', 'affiliate', 'Affiliate', __iconNode);

export default IconAffiliate;